import getDashboardName from 'common/src/modules/analytics/utils/getDashboardName';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import _find from 'lodash/find';
import _map from 'lodash/map';
import {z} from 'zod';
import {AccountAnalyticsToolName} from '../accountAnalyticsAgent.enums';

const inputSchema = z.object({
  dashboardId: z
    .number()
    .describe('The ID of the editable dashboard to remove')
    .nullable()
    .optional(),
  dashboardName: z
    .string()
    .describe('The name of the editable dashboard to remove')
    .nullable()
    .optional(),
});

function deleteAccountDashboardTool(store: CLStore) {
  async function execute({
    input: {dashboardId, dashboardName},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const state = store.getState();
    const {
      dashboardPage: {dashboards, dashboardId: currentDashboardId},
    } = state;

    const accountDashboards = _map(dashboards, (dashboard) => ({
      ...dashboard,
      name: getDashboardName(dashboard),
    }));

    const dashboardToDelete = _find(
      accountDashboards,
      ({id, name}) => id === dashboardId || name === dashboardName || id === currentDashboardId,
    );

    if (!dashboardToDelete) {
      return toolError('Dashboard not found');
    }

    routingService.redirectTo(Routes.Dashboard);

    return toolResult('Dashboard deleted successfully');
  }

  return tool({
    name: AccountAnalyticsToolName.DeleteAccountDashboard,
    displayName: 'Deleting dashboard',
    description: 'delete a dashboard',
    execute,
    inputSchema,
  });
}

export default deleteAccountDashboardTool;
